export default {
    getPartnerFields: state => state.partnerFields,
    getPartnerFormActions: state => state.partnerFormActions,

    getPartnerSiteFormActions: state => state.partnerSiteFormActions,

    getPositionsRowActions: state => state.positionsRowActions,
    getPositionsDataTableOptions: state => state.positionsDataTableOptions,
    getPositionsActions: state => state.positionsActions,
    getPositionsSearchFields: state => state.positionsSearchFields,
    getPositionsFormActions: state => state.positionsFormActions,
    getPositionsHeaderFields: state => state.positionsHeaderFields,

    getContactDataTableOptions: state => state.contactDataTableOptions,
    getContactActions: state => state.contactActions,
    getContactSearchFields: state => state.contactSearchFields,
    getContactFormActions: state => state.contactFormActions,
    getContactRowActions: state => state.contactRowActions,
    getContactHeaderFields: state => state.contactHeaderFields,

    getEmployeesActions: state => state.employeesActions,
    getEmployeesRowActions: state => state.employeesRowActions,
    getEmployeesHeaderFields: state => state.employeesHeaderFields,
    getEmployeesDisplayedFields: state => state.employeesDisplayedFields,
    getEmployeesFormActions: state => state.employeesFormActions,
    getEmployeesSearchFields: state => state.employeesSearchFields,
    getAdditionalTableConfig: state => state.additionalTableConfig,

    getWorkerSearchFields: state => state.workerSearchFields,

    getPatientActions: state => state.patientActions,
    getPatientRowActions: state => state.patientRowActions,
    getPatientHeaderFields: state => state.patientHeaderFields,
    getPatientDisplayedFields: state => state.patientDisplayedFields,
    getPatientFormActions: state => state.patientFormActions,
    getPatientDataTableOptions: state => state.patientDataTableOptions,
}
